import { useSuspenseQuery } from "@tanstack/react-query";
import { myDashboardApi } from "@/features/my-dashboard/api";

const useGetMyDashboardLinkedUrlSiteInfo = (buyer_id?: number) => {
  const { data: linkedUrlSiteInfo } = useSuspenseQuery({
    queryFn: () => myDashboardApi.getLinkedUrlSiteInfo(buyer_id),
    queryKey: ["my-dashboard", "link-url", buyer_id],
  });

  return {
    linkedUrlSiteInfo,
  };
};

export default useGetMyDashboardLinkedUrlSiteInfo;
